import React, { FC } from 'react';
import { AddressDisplay } from '../address_display/AddressDisplay';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getBuyerCompanySettingValue } from '../../utils/AuthUtils';

interface BillToInfoBannerProps {
	location: any;
	workOrder: any;
	userType: string;
	companyConfig: any;
	currentUser: any;
}

export const BillToInfoBanner: FC<BillToInfoBannerProps> = ({
	location,
	workOrder,
	userType,
	companyConfig,
	currentUser,
}) => {
	const enableBillTo = nullSafeGet(
		'buyerCompany.buyerCompanySettings.config.locationConfig.enableBillToAddressesForLocation',
		workOrder
	);

	if (!enableBillTo) return null;

	const billToData = nullSafeGet('invoicesBillTo', location);
	const buyerCompanyName = nullSafeGet('buyerCompany.name', workOrder);
	const billToName = nullSafeGetOrElse('billTo', billToData, buyerCompanyName);
	if (!billToName) return null;

	const locationPrimaryAddress = nullSafeGet('buyerFacility.primaryAddress', location);
	const serviceAddress = nullSafeGet('serviceAddress.sameAsLocation', billToData)
		? locationPrimaryAddress
		: nullSafeGet('serviceAddress', billToData) || locationPrimaryAddress;

	return (
		<div className="mb-8">
			<div className="h4medium mb-4 text-center text-character-secondary">
				Please ensure your invoice is billed to the following
			</div>
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
				<div className="rounded border border-solid border-grey-6 p-4">
					<div className="bodymedium mb-2 text-grey-7">Bill to:</div>
					<div className="bodyregular text-character-secondary">{billToName}</div>
				</div>
				<div className="rounded border border-solid border-grey-6 p-4">
					<div className="bodymedium mb-2 text-grey-7">Service Address:</div>
					<div className="text-sm leading-relaxed text-gray-700">
						<AddressDisplay
							className="bodyregular text-character-secondary"
							address={serviceAddress}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
